import { ConfigProvider } from 'antd';
import enGB from 'antd/locale/en_GB';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';

dayjs.locale('en-gb');

export function AntConfigProvider({ children }: { children?: React.ReactNode }) {
  return (
    <ConfigProvider
      locale={enGB}
      theme={{
        cssVar: true,
        components: {
          Card: {
            paddingLG: 0,
          },
          Layout: {
            colorBgLayout: 'none',
          },
          Input: {
            fontFamily: 'Outfit',
          },
          Table: {
            fontFamily: 'Outfit',
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
